import type { ModelVersion, MultiFrameTransition } from '@/app/types';
import { getAvailableOptions } from './validate-settings';

/**
 * 创建默认转场项
 */
export const createDefaultTransition = (
  from: number,
  to: number,
  prompt?: string,
  duration?: number,
): MultiFrameTransition => {
  return {
    duration: duration ?? 5,
    prompt,
    from,
    to,
  };
};

/**
 * 调整转场索引：当删除图片时，更新转场的 from/to 索引
 * @param transitions 转场数组
 * @param removedIndex 被删除的图片索引
 * @returns 调整后的转场数组
 */
export const adjustTransitionIndices = (
  transitions: MultiFrameTransition[],
  removedIndex: number,
): MultiFrameTransition[] => {
  return transitions.map((t) => {
    const newFrom = t.from >= removedIndex ? t.from - 1 : t.from;
    const newTo = t.to > removedIndex ? t.to - 1 : t.to;
    return {
      ...t,
      from: newFrom,
      to: newTo,
    };
  });
};

/**
 * 验证并修正 duration 值，确保在合法范围内
 * @param duration 待验证的 duration 值
 * @param modelVersion 模型版本
 * @returns 修正后的 duration 值
 */
export const validateAndFixDuration = (duration: number | undefined, modelVersion: ModelVersion | string): number => {
  if (!duration) {
    return 5; // 默认值
  }

  const availableDurations = getAvailableOptions(modelVersion as ModelVersion, 'img2video').duration || [];

  // 检查 duration 是否在可用选项中
  const isValidDuration = availableDurations.includes(duration.toString());

  if (!isValidDuration && availableDurations.length > 0) {
    // 如果不在合法范围内，使用第一个可用值
    return Number.parseInt(availableDurations[0], 10);
  }

  return duration;
};
